import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { BooleanField, ReferenceManyField, TextField } from 'react-admin';
import { Alert } from 'shared/mui/Alert/Alert';
import { DateTimeField } from 'shared/react-admin/Fields';

import { DatagridStyled } from './OrdersShowNotifications.styled';

export const OrdersShowNotificationsList: React.FC = () => {
  const t = useTypedTranslate();

  return (
    <ReferenceManyField
      label={false}
      reference="order_notifications"
      sort={{ field: 'id', order: 'ASC' }}
      target="order"
    >
      <DatagridStyled
        bulkActionButtons={false}
        empty={<Alert severity="info">{t('app.orders.notifications.empty')}</Alert>}
      >
        <TextField label={t('app.orders.notifications.id')} source="originId" />
        <BooleanField label={t('app.orders.notifications.delivered')} source="delivered" />
        <TextField label={t('app.orders.notifications.attempts')} source="attempts" />
        <DateTimeField
          emptyText="—"
          label={t('app.orders.notifications.nextAttempt')}
          source="nextAttempt"
        />
      </DatagridStyled>
    </ReferenceManyField>
  );
};
